export enum WidgetType {
    Count = 1,
    Chart = 2,
    TotalRevenue = 3,
    PharmacyDashboard =4,
    TableView = 5
}